import { Loader } from '@zorro/design-system/v2/Loader';
import { Modal } from '@zorro/design-system/v2/Modal';
import { Progress } from '@zorro/design-system/v2/Progress';
import { Group, Stack, Text } from '@zorro/web/design-system';
import { useWorkflowProgress } from '@zorro/web/ui-utils';

type Props = {
  correlationId: string | null;
  onComplete?: () => void;
  onError?: () => void;
  onClose?: () => void;
};

const TITLE = 'Updating onboarding periods';

export function OepUpdateWorkflowProgressModal({
  correlationId,
  onComplete,
  onError,
  onClose,
}: Props) {
  const { workflow, progress, status, isPolling } = useWorkflowProgress(
    correlationId,
    undefined,
    { onComplete, onError }
  );

  const opened = !!correlationId && isPolling && status === 'RUNNING';

  if (!opened) return null;

  const processed = workflow?.processedItems ?? 0;
  const total = workflow?.totalItems ?? 0;
  const percent = Math.min(100, Math.round((progress || 0) * 100));

  return (
    <Modal
      isOpen={opened}
      onClose={onClose ?? (() => {})}
      size="lg"
      title={TITLE}
      shouldCloseOnEscape={false}
      shouldCloseOnClickOutside={false}
    >
      <Stack gap="sm">
        <Group align="center" gap="xs">
          <Loader />
          <Text fw={600}>Processing employee onboarding periods</Text>
        </Group>
        <Progress value={percent} />
        <Text size="sm" c="dimmed">
          {processed} / {total} employees processed
        </Text>
      </Stack>
    </Modal>
  );
}
